// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
// css
import '../src/application';
import 'angular-material/modules/scss/angular-material';
import '@material-ui/core/styles';
import 'ng-sortable/source/ng-sortable.css';
import 'angular-toastr/dist/angular-toastr.css';
import 'angularjs-color-picker/dist/angularjs-color-picker.css';

// js
import 'vendor';
import 'angular/app';

// angular lowercase is deprecated but we have libs that still use this
angular.lowercase = text => text.toLowerCase();
